export const platformPositionColors = {
  sleeper: {
    light: {
      RB: "rgba(143, 242, 202, 0.8)",
      WR: "rgba(86, 201, 248, 0.8)",
      QB: "rgba(239, 116, 161, 0.8)",
      TE: "rgba(254, 174, 88, 0.8)",
      K: "rgba(182, 185, 255, 0.8)",
      DEF: "rgba(191, 117, 93, 0.8)",
      DST: "rgba(191, 117, 93, 0.8)",
    },
    dark: {
      RB: "rgba(143, 242, 202, 0.8)",
      WR: "rgba(86, 201, 248, 0.8)",
      QB: "rgba(239, 116, 161, 0.8)",
      TE: "rgba(254, 174, 88, 0.8)",
      K: "rgba(182, 185, 255, 0.8)",
      DEF: "rgba(191, 117, 93, 0.8)",
      DST: "rgba(191, 117, 93, 0.8)",
    },
  },
  espn: {
    light: {
      QB: "rgba(234, 74, 74, 0.8)",
      RB: "rgba(80, 183, 72, 0.8)",
      WR: "rgba(30, 115, 190, 0.8)",
      TE: "rgba(245, 166, 35, 0.8)",
      K: "rgba(189, 16, 224, 0.8)",
      DEF: "rgba(155, 155, 155, 0.8)",
      DST: "rgba(155, 155, 155, 0.8)",
    },
    dark: {
      QB: "rgba(254, 168, 195, 0.8)",
      RB: "rgba(255, 144, 0, 0.8)",
      WR: "rgba(1, 199, 242, 0.8)",
      TE: "rgba(48, 239, 221, 0.8)",
      K: "rgba(189, 16, 224, 0.8)",
      DEF: "rgba(155, 155, 155, 0.8)",
      DST: "rgba(155, 155, 155, 0.8)",
    },
  },
  yahoo: {
    light: {
      QB: "rgb(153, 109, 0)",
      RB: "rgb(255, 82, 87)",
      WR: "rgb(0, 131, 67)",
      TE: "rgb(57, 0, 125)",
      K: "rgb(206, 56, 0)",
      DEF: "rgb(91, 99, 106)",
      DST: "rgb(91, 99, 106)",
    },
    dark: {
      QB: "rgb(255, 167, 0)",
      RB: "rgb(204, 14, 37)",
      WR: "rgb(0, 209, 94)",
      TE: "rgb(144, 124, 255)",
      K: "rgb(255, 110, 12)",
      DEF: "rgb(199, 205, 210)",
      DST: "rgb(199, 205, 210)",
    },
  },
  cbs: {
    light: {
      QB: "rgba(193, 39, 45, 0.8)",
      RB: "rgba(58, 157, 35, 0.8)",
      WR: "rgba(0, 114, 188, 0.8)",
      TE: "rgba(255, 179, 0, 0.8)",
      K: "rgba(142, 68, 173, 0.8)",
      DEF: "rgba(127, 140, 141, 0.8)",
      DST: "rgba(127, 140, 141, 0.8)",
    },
    dark: {
      QB: "rgba(193, 39, 45, 0.8)",
      RB: "rgba(58, 157, 35, 0.8)",
      WR: "rgba(0, 114, 188, 0.8)",
      TE: "rgba(255, 179, 0, 0.8)",
      K: "rgba(142, 68, 173, 0.8)",
      DEF: "rgba(127, 140, 141, 0.8)",
      DST: "rgba(127, 140, 141, 0.8)",
    },
  },
  nfl: {
    light: {
      QB: "rgba(186, 12, 47, 0.8)",
      RB: "rgba(0, 151, 57, 0.8)",
      WR: "rgba(0, 87, 149, 0.8)",
      TE: "rgba(255, 163, 0, 0.8)",
      K: "rgba(81, 29, 126, 0.8)",
      DEF: "rgba(189, 195, 199, 0.8)",
      DST: "rgba(189, 195, 199, 0.8)",
    },
    dark: {
      QB: "rgba(186, 12, 47, 0.8)",
      RB: "rgba(0, 151, 57, 0.8)",
      WR: "rgba(0, 87, 149, 0.8)",
      TE: "rgba(255, 163, 0, 0.8)",
      K: "rgba(81, 29, 126, 0.8)",
      DEF: "rgba(189, 195, 199, 0.8)",
      DST: "rgba(189, 195, 199, 0.8)",
    },
  },
}; 